/** @format */

import { ItemLoaders } from '../../core/loaders/ItemLoaders';
import Order from '../../interfaces/forms/Order';
import Filter from '../../interfaces/forms/Filter';
import { FormGeneralHelper } from '../../helpers/FormGeneral';
import moment from 'moment';
import i18next from 'i18next';
import { ExportToCsv } from 'export-to-csv';
import { DateHelperTs } from '../../helpers/DateHelperTs';
import { InvoiceCollectionInterface, InvoiceInterface } from '../../interfaces/platform/InvoiceInterface';
import { CurrencyHelper } from '../../helpers/CurrencyHelper';
import PlusNotifyInterface from "../../interfaces/platform/PlusNotifyInterface";
import I18n from "../../components/Translate/I18n";
import React from "react";
import {PlusNotifyHelper} from "../../helpers/PlusNotifyHelper";

const _ = require('underscore');

interface NotifyToCsvData {
    id: number
    platformResellerName: string | null
    msisdn: string | null
    typeGroupId: number | string | null;
    notificationType: string | number;
    description: string | null
    eventDate: string | null
    createdAt: string | null
}

export class NotificationToCsv {
    private readonly itemLoader: ItemLoaders;

    constructor(itemLoader: ItemLoaders) {
        this.itemLoader = itemLoader;
    }

    exportToCsv = (orders: Array<Order>, filters: Array<Filter>, showMainLoader: (show: boolean) => void): void => {
        const extendFilter = _.clone(filters);
        extendFilter.push({ name: 'pagination', value: 'false' });
        showMainLoader(true);
        this.itemLoader.getListWithCallback(
            FormGeneralHelper.getByUri(FormGeneralHelper.getPath('/notifies')),
            'notify_loader',
            extendFilter,
            orders,
            (items: {'hydra:member': Array<PlusNotifyInterface>, 'hydra:totalItems': number}): void => {
                this.prepareCsv(items);
                showMainLoader(false);
            },
            { propagateDataToCallback: true, dispatchAfterCallback: false }
        );
    };

    prepareCsv = (items: {'hydra:member': Array<PlusNotifyInterface>, 'hydra:totalItems': number}): void => {
        const csvList = this.prepareCsvData(items);
        const options = {
            filename: 'notify_report' + moment().format('YYYYMMDD[_]HHmm'),
            fieldSeparator: ';',
            quoteStrings: '"',
            decimalSeparator: '.',
            showLabels: true,
            showTitle: false,
            title: 'Raport z notifikacji',
            useTextFile: false,
            useBom: true,
            useKeysAsHeaders: false,
            headers: [
                i18next.t('prov:list.id'),
                i18next.t('prov:list.partner'),
                i18next.t('prov:list.msisdn'),
                i18next.t('prov:list.notification_type'),
                i18next.t('prov:list.notification_direction'),
                i18next.t('prov:list.notification_description'),
                i18next.t('prov:list.event_date'),
                i18next.t('prov:list.created_at')
            ],
        };
        const exportCsv = new ExportToCsv(options);
        exportCsv.generateCsv(csvList);
    };

    prepareCsvData = (items: {'hydra:member': Array<PlusNotifyInterface>, 'hydra:totalItems': number}): Array<NotifyToCsvData> => {
        const csvList: Array<NotifyToCsvData> = [];
        if (items['hydra:member'] && items['hydra:totalItems'] && items['hydra:totalItems'] > 0) {
            items['hydra:member'].map((notification: PlusNotifyInterface) => {
                let typeGroupId = '';
                if(notification.typeGroupId) {
                    typeGroupId = i18next.t(PlusNotifyHelper.notificationGroupType(notification.typeGroupId.toString()));
                }

                let notificationType = '';
                if(notification.notificationType !== '1001' && notification.notify.threholddirection) {
                    notificationType = i18next.t(`prov:list.${notification.notify.threholddirection}`)
                } else if (notification.notificationType !== '1001' && !notification.notify.threholddirection) {
                    notificationType = i18next.t('prov:list.NONE')
                } else if (notification.notificationType === '1001' && notification.notificationDirection) {
                    notificationType = i18next.t(notification.notificationDirection === 2 ? 'prov:list.DOWN' : 'prov:list.UP');
                } else {
                    notificationType = '';
                }

                csvList.push({
                    id: notification.id,
                    platformResellerName: notification.platformResellerName,
                    msisdn: notification.msisdn && notification.msisdn.length === 9 ? `48${notification.msisdn}` : notification.msisdn,
                    typeGroupId: typeGroupId,
                    notificationType: notificationType,
                    description: notification.description,
                    eventDate: notification.eventDate ? DateHelperTs.format(notification.eventDate) : '',
                    createdAt: DateHelperTs.format(notification.createdAt)
                });
            });
        }
        return csvList;
    };
}
